import { StrictLocalizeFunction } from "@faire/web--source/common/localization";

export enum StoreType {
  GIFT = "Gift Store",
  CLOTHING = "Clothing Boutique",
  HOME_DECOR = "Home Decor Store",
  SPA_OR_SALON = "Spa / Salon / Beauty Store",
  GENERAL = "General Store / Mercantile",
  FLORIST_OR_GARDEN = "Florist / Garden Store",
  KIDS_OR_TOY = "Kids / Toy Store",
  CAFE_OR_RESTAURANT = "Cafe / Restaurant",
  FITNESS_OR_YOGA = "Fitness / Yoga Studio",
  FURNITURE = "Furniture Store",
  PET = "Pet Store",
  BOOK = "Bookstore",
  GROCERY_OR_LIQUOR = "Grocery / Liquor Store",
  OTHER = "Other",
}

export const storeTypeToDisplayName = (
  storeType: StoreType,
  strictLocalize: StrictLocalizeFunction
) => {
  switch (storeType) {
    case StoreType.GIFT:
      return strictLocalize({ defaultMessage: "Gift Store" });
    case StoreType.CLOTHING:
      return strictLocalize({ defaultMessage: "Apparel Boutique" });
    case StoreType.HOME_DECOR:
      return strictLocalize({ defaultMessage: "Home Decor Store" });
    case StoreType.SPA_OR_SALON:
      return strictLocalize({ defaultMessage: "Spa or Salon" });
    case StoreType.GENERAL:
      return strictLocalize({
        defaultMessage: "General Store",
        description: { text: "A store that sells a wide variety of goods" },
      });
    case StoreType.FLORIST_OR_GARDEN:
      return strictLocalize({ defaultMessage: "Florist or Garden Store" });
    case StoreType.KIDS_OR_TOY:
      return strictLocalize({ defaultMessage: "Kids or Toy Store" });
    case StoreType.CAFE_OR_RESTAURANT:
      return strictLocalize({ defaultMessage: "Cafe or Restaurant" });
    case StoreType.FITNESS_OR_YOGA:
      return strictLocalize({ defaultMessage: "Fitness or Yoga Studio" });
    case StoreType.FURNITURE:
      return strictLocalize({ defaultMessage: "Furniture Store" });
    case StoreType.PET:
      return strictLocalize({ defaultMessage: "Pet Store" });
    case StoreType.BOOK:
      return strictLocalize({ defaultMessage: "Book Store" });
    case StoreType.GROCERY_OR_LIQUOR:
      return strictLocalize({ defaultMessage: "Grocery or Liquor Store" });
    case StoreType.OTHER:
    default:
      return strictLocalize({
        defaultMessage: "Other",
        description: {
          text: "A store type that isn't one of the available options",
          img: "https://cdn.faire.com/fastly/897fc904916dfcfff52e2f8d9286613bb66d45e99e07a254be9dd1d728135fd2.png",
        },
      });
  }
};
